import React from 'react';

export default function LandingSectionDivider() {
  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 my-4 sm:my-6" aria-hidden="true">
      <div className="h-px bg-gradient-to-r from-transparent via-sky-300/80 to-transparent" />
      <div className="mt-3 h-1.5 w-24 mx-auto rounded-full bg-gradient-to-r from-sky-500 via-blue-500 to-blue-400 opacity-80" />
    </div>
  );
}
